import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Entete from "./dataset/Entete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "./ThemeContext";
import { Button, CircularProgress } from "@mui/material";
import API from "../Authentification/apiAdmin";
import { toast } from "react-toastify";
import img_electromenager_dashboard from "../assets/Images/img_electromenager_dashboard.webp";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { getProductImage } from "../../Utils/Cloudinary";
// import "../../Styles/AdminDashbord/productGrid.css";

const ProductGrid = () => {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const [products, setProducts] = useState([]);
  const [dropActive, setDropActive] = useState("Nom");
  const [category, setCategory] = useState("Electroménager");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingPopular, setLoadingPopular] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const token = localStorage.getItem("adminToken");

  const togglePopular = async (productId) => {
    setLoadingPopular(productId);

    try {
      const response = await API.put(
        `/admin/products/${productId}/toggle-popular`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const { is_popular } = response.data;

      setProducts((prev) =>
        prev.map((p) => (p.id === productId ? { ...p, is_popular } : p)),
      );

      toast.success(
        is_popular
          ? "Produit marqué comme populaire"
          : "Produit retiré des populaires",
      );
    } catch (error) {
      console.error(error);
      toast.error("Impossible de modifier le statut populaire");
    } finally {
      setLoadingPopular(null);
    }
  };

  const fetchProducts = async (searchOverride) => {
    const searchTerm = searchOverride !== undefined ? searchOverride : search;
    setLoading(true);
    try {
      const response = await API.get(`/admin/products`, {
        params: {
          page,
          sort: dropActive,
          category,
          ...(searchTerm.trim() ? { search: searchTerm.trim() } : {}),
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      setProducts(response.data.data);
      setTotalPages(response.data.total_pages || 1);
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors du chargement des produits");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [page, dropActive, category]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchProducts();
  };

  const handleClearSearch = () => {
    setSearch("");
    setPage(1);
    fetchProducts("");
  };

  const handleCategoryChange = (newCategory) => {
    setCategory(newCategory);
    setSearch("");
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer ce produit ?")) return;

    try {
      await API.delete(`/admin/products/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Produit supprimé avec succès");
      fetchProducts();
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de la suppression");
    }
  };

  return (
    <div className="product-grid-page">
      <Entete title="Grille des produits" />

      {/* FILTRES */}
      <div className="">
        <div className="row mt-3 g-2">
          {/* Catégories */}
          <div
            className="shadow-sm border border-1 me-md-2 col-12 col-md-3 p-2 d-flex align-items-center"
            style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
          >
            <div className="w-100">
              <span className="petit_titre fw-bold">{category}</span>
            </div>
          </div>
          <div
            className="shadow-sm border border-1 me-md-2 col-12 col-md-4 p-2 d-flex align-items-center"
            style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
          >
            <div className="dropdown w-100" style={{ cursor: "pointer" }}>
              <span
                className="dropdown-toggle petit_titre fw-bold"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Catégories de produits {category && `: ${category}`}
              </span>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                <li className="dropdown-item" onClick={() => handleCategoryChange("Electroménager")}>Electroménager</li>
                <li className="dropdown-item" onClick={() => handleCategoryChange("Produits Locaux")}>Produits Locaux</li>
                <li className="dropdown-item" onClick={() => handleCategoryChange("Produits Frais")}>Produits Frais</li>
                <li className="dropdown-item" onClick={() => handleCategoryChange("Epicerie")}>Epicerie</li>
                <li className="dropdown-item" onClick={() => handleCategoryChange("Droguerie")}>Droguerie</li>
                <li className="dropdown-item" onClick={() => handleCategoryChange("Divers")}>Divers</li>
                <li className="dropdown-item" onClick={() => handleCategoryChange("Boissons")}>Boissons</li>
              </ul>
            </div>
          </div>

          {/* Tri */}
          <div
            className="shadow-sm border border-1 col-12 col-md-3 p-2 d-flex align-items-center"
            style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
          >
            <div className="dropdown w-100" style={{ cursor: "pointer" }}>
              <span
                className="dropdown-toggle petit_titre fw-bold"
                id="dropdownMenuButton2"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Trier par : {dropActive}
              </span>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton2"
              >
                <li className="dropdown-item" onClick={() => setDropActive("Nom")}>Nom</li>
                <li className="dropdown-item" onClick={() => setDropActive("Meilleurs ventes")}>Meilleurs ventes</li>
                <li className="dropdown-item" onClick={() => setDropActive("Pires ventes")}>Pires ventes</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Recherche */}
        <div className="row mt-2">
          <div className="col-md-6 col-12">
            <form onSubmit={handleSearchSubmit}>
              <div
                className="d-flex align-items-center shadow-sm border border-1 px-2"
                style={{
                  backgroundColor: theme === "dark" ? "black" : "white",
                }}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2 text-muted" />
                <input
                  type="text"
                  className="border-0 flex-grow-1 py-2 texte_brut"
                  style={{
                    outline: "none",
                    backgroundColor: "transparent",
                    color: theme === "dark" ? "white" : "black",
                  }}
                  placeholder={`Rechercher dans ${category}... (nom ou référence)`}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                {search && (
                  <button
                    type="button"
                    className="btn btn-sm border-0"
                    onClick={handleClearSearch}
                    aria-label="Effacer la recherche"
                  >
                    ✕
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* GRID PRODUITS */}
      <div className="">
        <div className="row mt-4">
          {loading ? (
            <div className="text-center my-5">
              <CircularProgress />
            </div>
          ) : products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="col-md-3 col-6 py-2 px-2">
                <div
                  className="shadow-sm border border-1 pb-2 h-100"
                  style={{
                    backgroundColor: theme === "dark" ? "black" : "white",
                  }}
                >
                  <div className="">
                    <div className="col">
                      <img
                        src={getProductImage(product.image)}
                        alt={product.name}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="px-2">
                    <h5 className="taux_moyen fw-normal mt-2">
                      {product.name}
                    </h5>
                    <p className="texte_brut m-0">
                      Prix fixe : {product.price} FCFA
                    </p>
                    <p className="texte_brut m-0">
                      Prix de vente : {product.price} FCFA
                    </p>
                    <p className="texte_brut m-0" style={{ color: "green" }}>
                      Disponible : {product.disponibility}
                    </p>
                    <p className="texte_brut m-0" style={{ color: "blue" }}>
                      Vendu: {product.selled}
                    </p>
                    <div className="row mt-2">
                      <Button
                        className="col me-2"
                        style={{
                          borderRadius: "15px",
                          borderColor: "blue",
                          color: "blue",
                        }}
                        onClick={() =>
                          navigate(`/admin/addProduct/${product.id}`)
                        }
                      >
                        Modifier
                      </Button>
                      <Button
                        className="col-6"
                        style={{
                          borderRadius: "15px",
                          borderColor: "red",
                          color: "red",
                        }}
                        onClick={() => handleDelete(product.id)}
                      >
                        Supprimer
                      </Button>
                    </div>
                    <FormGroup className="mt-2">
                      <FormControlLabel
                        label="Populaire"
                        control={
                          <Switch
                            checked={Boolean(product.is_popular)}
                            onChange={() => togglePopular(product.id)}
                            color="secondary"
                            size="small"
                            disabled={loadingPopular === product.id}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center petit_titre">
              {search
                ? `Aucun produit trouvé pour "${search}" dans ${category}`
                : "Aucun produit trouvé"}
            </div>
          )}
        </div>
      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <nav
          aria-label="Pagination"
          className="d-flex justify-content-center mt-3"
        >
          <ul className="pagination mb-0">
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setPage(page - 1)}>
                Précédent
              </button>
            </li>
            <li className="page-item disabled">
              <span className="page-link">
                {page} / {totalPages}
              </span>
            </li>
            <li
              className={`page-item ${page === totalPages ? "disabled" : ""}`}
            >
              <button className="page-link" onClick={() => setPage(page + 1)}>
                Suivant
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default ProductGrid;